import { createContext, useContext } from 'react';

import { ContentValue } from './types';

export const SettingsContext = createContext<ContentValue>({
  callbacks: {},
});

export const useSettings = (): [ContentValue['callbacks']] => {
  const { callbacks } = useContext(SettingsContext);
  return [callbacks];
};
